import LocalizedStrings from 'react-localization';
import getServerErrorMsg from './serverErrorMessage';
import calendar from './calendar';


export default new LocalizedStrings({
    en: {
        serverMessage: getServerErrorMsg('en'),
        loginToSalesforce: 'Login to Salesforce',
        loginToVend: 'Login to Vend HQ',
        titleError: 'Invalid request',
        common: {
            save: 'Save',
            cancel: 'Cancel',
            new: 'New',
            edit: 'Edit',
            delete: 'Delete',
            assign: 'Assign',
            action: 'Action',
            visible: 'Visible',
            hidden: 'Hidden',
            editable: 'Editable',
            readOnly: 'Read only',
            success: 'Success',
            incomplete: 'Some fields have not been completed succesfully. Please try again.',
            yes: 'Yes',
            no: 'No',
        },
        dialogue: {
            areYouSure: 'Are you sure',
            successDeleted: 'has been successfully deleted',
            willNotRecover: 'This item can not be recovered after you delete.',
            sendResetPwd: 'User will receive an email from wakatobi and there will be instruction to reset their password.',
        },
        menu: {
            app: 'Apps',
            userManagement: 'User Management',
            myAccount: 'My Account',
            notifications: 'Notification',
            logout: 'Logout',
        },
        users: {
            title: 'Gems User',
            description: 'On this page you can create, view and manage users.',
            newUser: 'New user',
            editUser: 'Edit user',
            generalInformation: 'General Information',
        },
        profile: {
            title: 'User Profile Setting',
            description: 'Please create profile by looking at the informational needs of a role. After creating the profile, please assign them to the user',
            newProfile: 'New Profile',
            columnName: {
                name: 'Profile Name',
                updatedAt: 'Last Modified Date',
                createdAt: 'Created Date',
                totalUserAssigned: 'Total User Assigned',
                description: 'Description',
            },
            successProfileSaved: 'Profile has been saved succesfully',
        },
        resetPassword: {
            oldPassword: 'Old Password',
            newPassword: 'New Password',
            newPasswordRepeat: 'Repeat New Password',
            btnResetPwd: 'Reset Password',
            notEqualPassword: 'Both password not equal, please try again.',
        },
        calendar: calendar.en,
    },
    id: {
        serverMessage: getServerErrorMsg('id'),
        loginToSalesforce: 'Masuk Salesforce',
        loginToVend: 'Masuk VendHq',
        titleError: 'Terdapat kesalahan di server',
        common: {
            save: 'Simpan',
            cancel: 'Batal',
            new: 'Baru',
            edit: 'Ubah',
            delete: 'Hapus',
            assign: 'Tetapkan',
            action: 'Aksi',
            visible: 'Terlihat',
            hidden: 'Tersembunyi',
            editable: 'Dapat Diubah',
            readOnly: 'Hanya Baca',
            success: 'Sukses',
            incomplete: 'Beberapa field yang dibutuhkan belum dilengkapi.',
            yes: 'Ya',
            no: 'Tidak',
        },
        dialogue: {
            areYouSure: 'Apakah anda yakin',
            successDeleted: 'telah berhasil dihapus',
            willNotRecover: 'Item ini tidak dapat dikembalikan setelah di hapus.',
            sendResetPwd: 'Pengguna akan menerima email dari wakatobi. Di dalam email akan terdapat instruksi untuk melakukan reset password',
        },
        menu: {
            app: 'Aplikasi',
            userManagement: 'Manajemen User',
            myAccount: 'Akun Saya',
            notifications: 'Notifikasi',
            logout: 'Keluar',
        },
        users: {
            title: 'Pengguna Gems',
            description: 'Di halaman ini anda dapat membuat, mengubah, dan menghapus pengguna.',
            newUser: 'Pengguna baru',
            editUser: 'Mengubah pengguna',
            generalInformation: 'Informasi Umum',
        },
        profile: {
            title: 'Profile Setting Pengguna',
            description: `Anda dapat membuat profile dengan melihat kebutuhan dari masing-masing peran pengguna sistem. 
                Setelah membuat profile anda dapat tetapkan profil tersebut ke pengguna.`,
            newProfile: 'Profil Baru',
            columnName: {
                name: 'Nama Profile',
                updatedAt: 'Terakhir Diubah',
                createdAt: 'Tanggal Dibuat',
                totalUserAssigned: 'Jumlah Pengguna',
            },
            successProfileSaved: 'Profil telah tersimpan dengan baik.',
        },
        resetPassword: {
            oldPassword: 'Kata sandi lama',
            newPassword: 'Kata sandi baru',
            newPasswordRepeat: 'Ulangi kata sandi baru',
            btnResetPwd: 'Reset kata sandi',
            notEqualPassword: 'Kedua kata sandi tidak sama. Coba periksa kembali.',
        },
        calendar: calendar.id,
    },
});
